import { ReactNode, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { employeeSchema } from '../../validations/employeeSchema';

export interface EmployeeFormValues {
  // Personal Info
  empCode: string;
  fname: string;
  lname: string;
  gender: string;
  dob: string;
  maritalStatus: string;
  bloodGroup: string;
  nationality: string;
  religion?: string;
  profilePhoto?: File | string;

  // Contact Info
  officialEmail: string;
  personalEmail: string;
  mobileNumber: string;
  altContact: string;
  presentAddress: string;
  permanentAddress: string;
  city: string;
  state: string;
  country: string;
  pinCode: string;

  // Job Info
  department: string;
  designation: string;
  employmentType: string;
  workMode: string;
  dateOfJoining: string;
  confirmationDate: string;
  manager: string;

  // Shift & Attendance
  shiftName: string;
  attendanceMode: string;
  biometricId: string;
  weeklyOffDays: string; // Use string for comma-separated input, convert to array later

  // Payroll
  ctc: number | string;
  paymentMode: string;
  bankDetails: {
    bankName: string;
    accountNumber: string;
    ifsc: string;
  };
  pan: string;
  aadhaar: string;

  // KYC & profile;
  // documents: {
  //   bankAccountDocument:string;
  //   resume: string;
  //   panCard: {
  //     file: string;
  //     verified: boolean;
  //   };
  //   aadhaarCard: {
  //     file: string;
  //     verified: boolean;
  //   };
  //   offerLetter: string;
  // };

  // Skills & Experience
  skills: string;
  offerLetter: File | string;
  certifications: string;
  experience: {
    totalYears: number | string;
    relevantYears: number | string;
  };

  // IT Assets
  laptopSerial: string;
  vpnInstalled: boolean;

  // Emergency
  emergencyContact: {
    name: string;
    number: string;
    relationship: string;
  };

  // Optional
  status?: string;
}


export const defaultValues: EmployeeFormValues = {
  empCode: '',
  fname: '',
  lname:'',
  gender: '',
  dob: '',
  maritalStatus: '',
  bloodGroup: '',
  nationality: '',
  religion: '',
  profilePhoto: '',

  officialEmail: '',
  personalEmail: '',
  mobileNumber: '',
  altContact: '',
  presentAddress: '',
  permanentAddress: '',
  city: '',
  state: '',
  country: '',
  pinCode: '',

  department: '',
  designation: '',
  employmentType: '',
  workMode: '',
  dateOfJoining: '',
  confirmationDate: '',
  manager: '',

  shiftName: '',
  attendanceMode: '',
  biometricId: '',
  weeklyOffDays: '',

  ctc: '',
  paymentMode: '',
  bankDetails: {
    bankName: '',
    accountNumber: '',
    ifsc: ''
  },
  pan: '',
  aadhaar: '',

  // documents: {
  //   bankAccountDocument:'',
  //   resume: '',
  //   panCard: { file: '', verified: false },
  //   aadhaarCard: { file: '', verified: false },
  //   offerLetter: ''
  // },

  skills: '',
  offerLetter:"",
  certifications: '',
  experience: {
    totalYears: '',
    relevantYears: ''
  },

  laptopSerial: '',
  vpnInstalled: false,

  emergencyContact: {
    name: '',
    number: '',
    relationship: ''
  },

  status: 'active'
};


export const FormProviderWrapper = ({
  children,
  initialData
}: {
  children: ReactNode;
  initialData?: Partial<EmployeeFormValues>;
}) => {
  const methods = useForm<EmployeeFormValues>({ defaultValues,resolver: yupResolver(employeeSchema), mode:"onChange",criteriaMode: "all"});

  useEffect(() => {
    if (initialData) {
      methods.reset({ ...defaultValues, ...initialData });
    }
  }, [initialData]);

  return <FormProvider {...methods}>{children}</FormProvider>;
};